export const THERES_NO_PLACE_LIKE_HOME_CAMPAIGN_TAG = "There's No Place Like Home" as const

function normaliseCampaignTag(tag: string): string {
  return tag
    .trim()
    .replaceAll('’', "'")
    .toLowerCase()
}

export function isTheresNoPlaceLikeHomeCampaignTag(tag: string): boolean {
  return normaliseCampaignTag(tag) === normaliseCampaignTag(THERES_NO_PLACE_LIKE_HOME_CAMPAIGN_TAG)
}

export function offerHasTheresNoPlaceLikeHomeCampaignTag(tags: Array<string> | undefined): boolean {
  return tags?.some(isTheresNoPlaceLikeHomeCampaignTag) ?? false
}
